import React, { useState } from "react";
import {
  Alert,
  IconButton,
  Slide,
  Snackbar as MuiSnackbar,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { AlertColor, AlertProps } from "@mui/material/Alert/Alert";
import { SnackbarOrigin } from "@mui/material/Snackbar";

type SnackbarProps = {
  level: AlertColor;
  message: string;
  anchorOrigin?: SnackbarOrigin;
  variant?: AlertProps["variant"];
};

export default function Snackbar({
  level,
  message,
  anchorOrigin = { vertical: "bottom", horizontal: "center" },
  variant,
}: SnackbarProps): React.ReactNode {
  const [snackbarOpen, setSnackbar] = useState(true);
  const closeSnackbar = () => setSnackbar(false);
  return (
    <MuiSnackbar
      open={snackbarOpen}
      anchorOrigin={anchorOrigin}
      TransitionComponent={Slide}
      autoHideDuration={12000}
      onClose={closeSnackbar}
    >
      <Alert
        sx={{ width: "100%" }}
        severity={level}
        variant={variant}
        action={
          <IconButton
            color="inherit"
            size="small"
            href=""
            onClick={closeSnackbar}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
      >
        {message}
      </Alert>
    </MuiSnackbar>
  );
}
